module.exports = __webpack_public_path__ + "img/razita-hero.7ff1e2bd.jpg";